export default "__VITE_ASSET__CteUTvBM__"